export enum ChannelParam{
    QRHome='QRHome',
    PortalEmail='Portal-Email',
    LinkCopy='LinkCopy',
    AppIntScreen='AppIntScreen'
}
